import { create } from 'zustand';

type TenantState = {
  tenantId: number | undefined;
  setTenantId: (id: number | undefined) => void;
};

export const useTenantStore = create<TenantState>((set) => ({
  tenantId: undefined,
  setTenantId: (id) => {
    set({ tenantId: id });
  },
}));
